import { Radio, RadioGroup } from "@chakra-ui/react";
import { FieldValues, UseControllerProps, useController } from "react-hook-form";
import { handleFieldChange } from "./handleFieldChange";
import { BoxProps, Flex } from "@chakra-ui/layout";

type RadioGroupProps<
  Option,
  TFieldValues extends FieldValues,
> = UseControllerProps<TFieldValues> & {
  options: ReadonlyArray<Option>;
  className?: string;
  renderOption: (option: Option) => JSX.Element | string;
  fullWidth?: boolean;
};

export function ControlledRadioGroup<Option, T extends FieldValues>({
  name,
  rules,
  shouldUnregister,
  control,
  options,
  renderOption,
  fullWidth,
  ...props
}: RadioGroupProps<Option, T> & BoxProps) {
  const { field } = useController({
    name,
    rules,
    shouldUnregister,
    control,
  });

  return (
    <RadioGroup data-testid={name}>
      <Flex direction="column" data-testid={name} gap={fullWidth ? 4 : 2} {...props}>
        {options.map((option, index) => {
          return (
            <Radio
              key={index}
              isChecked={JSON.stringify(field.value) === JSON.stringify(option)}
              onChange={() => {
                handleFieldChange(field, option);
              }}
              w={{ base: "100%", md: fullWidth ? "100%" : "75%" }}
            >
              {renderOption(option)}
            </Radio>
          );
        })}
      </Flex>
    </RadioGroup>
  );
}
